<template>
    <div>
        <div :class="{'buttons-footer':!showMenu,'buttons-footer-2':showMenu}">
            <button
                class="btn btn-dark"
                @click="Change_State_Conventions()"
            >
                    Convenciones
            </button>
            <button
                class="btn btn-dark"
                @click="Change_State_Colaborators()"
            >
                    Colaboradores
            </button>
        </div>

        <ConventionsModal v-if="showConventions" />

        <ColaboratorsModal v-if="showColaborators" />
    </div>
</template>

<script>

    import {mapState, mapMutations} from 'vuex';
    import ColaboratorsModal from '@/components/ColaboratorsModal/ColaboratorsModal.vue'
    import ConventionsModal from '@/components/ConventionsModal/ConventionsModal.vue';

    export default {
        name: 'ButtonsFooter',

        components: {
            ColaboratorsModal,
            ConventionsModal
        },

        computed: {
            ...mapState('station_id',['showMenu']),

            ...mapState('modals',['showConventions','showColaborators']),
        },

        methods: {
            ...mapMutations('modals',['Change_State_Conventions','Change_State_Colaborators'])
        }
    };
</script>

<style scoped lang="scss">
    .buttons-footer{
        position: absolute;
        right: .7rem;
        bottom: 1rem;
        z-index: 1;
    }

    .buttons-footer-2{
        position: absolute;
        right: 35.5rem;
        bottom: 1rem;
        z-index: 1;
    }

    .btn-dark{
        &:hover {
            background-color: $dark-color-transparent;
        }

        background-color: $bg-dark-color-transparent;
        border: 0;
        box-shadow: .2em .2em .5em $dark-color;
        font-weight: bold;
        margin: 0 .3rem;
    }

    @media (max-width: 600px) {
        .btn-dark {
            font-size: .6em;
        }
    }

    @media (max-height: 500px) {
        .btn-dark {
            font-size: .6em;
        }
    }

    @media (min-width: 1500px) {
        .btn-dark {
            font-size: 1.2em;
        }

        .button-position-2 {
            right: 45.5em;
        }
    }
</style>
